/* =================== CADASTRA LEAD =================== */
jQuery(document).ready(function ($) {

  // CADASTRA LEAD BASE
  var enviando_formulario = false;
  $("#form-lead").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = form.find("#enviar_lead");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
      closeModal("modal-lead");
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Enviando...");
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            $("#form-lead .campo").val("");
            window.location.href = $("#infos").data("url-base")+'obrigado';
            /* showAlert(
              "Sucesso",
              "Em breve você <b>receberá em seu e-mail ofertas</b> atualizadas para sua demanda.<br><br> Mas se preferir pode continuar <b>navegando em nossos anúncios!</b>",
              "success"
            ); */
            /* setTimeout(() => {
              location.reload();
            }, 8000); */
            /* setTimeout(() => {
              window.location.href = $("#infos").data("url-base")+'obrigado';
            }, 8000); */
          } else {
            showAlert("Erro", "Não foi possível enviar a mensagem.", "error");
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert("Erro", "Não foi possível enviar a mensagem.", "error");
          console.log("ajax error response type " + type);
        },
      });
    }
  });

  // CADASTRA LEAD INTERESSE
  $('.btn-cadlead').on('click', function(e){
    e.preventDefault();

    function volta_submit() {
      hideLoading();
    }

    var btn = $(this);
    var id = btn.data("id");
    var url = btn.data("url");
    $.ajax({
      url: url,
      type: "POST",
      data: {
        id: id
      },
      beforeSend: function() {
        showLoading();
        enviando_formulario = true;
      },
      success: function (data) {
        console.log(data);
        volta_submit();
        if (data == "ok") {
          showAlert(
            "Sucesso",
            "Seu interesse por esse anúncio foi gravado.<br> Continue navegando em nossos anúncios!",
            "success"
          );
          /* setTimeout(() => {
            window.location.href = $("#infos").data("url-base")+'anuncios';
          }, 8000); */
        } else {
          showAlert("Erro", "Não foi possível enviar ao interesse.", "error");
        }
      },
      error: function (xhr, type, exception) {
        volta_submit();
        showAlert("Erro", "Não foi possível enviar ao interesse.", "error");
        console.log("ajax error response type " + type);
      },
    });
  });

});
